/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockManageUserSummaryResVo } from './AdminStockManageUserSummaryResVo';
import {
    AdminStockManageUserSummaryResVoFromJSON,
    AdminStockManageUserSummaryResVoFromJSONTyped,
    AdminStockManageUserSummaryResVoToJSON,
    AdminStockManageUserSummaryResVoToJSONTyped,
} from './AdminStockManageUserSummaryResVo';

/**
 * 
 * @export
 * @interface ResponseAdminStockManageUserSummaryResVo
 */
export interface ResponseAdminStockManageUserSummaryResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminStockManageUserSummaryResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminStockManageUserSummaryResVo
     */
    message?: string;
    /**
     * 
     * @type {AdminStockManageUserSummaryResVo}
     * @memberof ResponseAdminStockManageUserSummaryResVo
     */
    data?: AdminStockManageUserSummaryResVo;
}

/**
 * Check if a given object implements the ResponseAdminStockManageUserSummaryResVo interface.
 */
export function instanceOfResponseAdminStockManageUserSummaryResVo(value: object): value is ResponseAdminStockManageUserSummaryResVo {
    return true;
}

export function ResponseAdminStockManageUserSummaryResVoFromJSON(json: any): ResponseAdminStockManageUserSummaryResVo {
    return ResponseAdminStockManageUserSummaryResVoFromJSONTyped(json, false);
}

export function ResponseAdminStockManageUserSummaryResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminStockManageUserSummaryResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminStockManageUserSummaryResVoFromJSON(json['data']),
    };
}

export function ResponseAdminStockManageUserSummaryResVoToJSON(json: any): ResponseAdminStockManageUserSummaryResVo {
    return ResponseAdminStockManageUserSummaryResVoToJSONTyped(json, false);
}

export function ResponseAdminStockManageUserSummaryResVoToJSONTyped(value?: ResponseAdminStockManageUserSummaryResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminStockManageUserSummaryResVoToJSON(value['data']),
    };
}

